<template>
  <div class="breakdown card">
    <h4 class="card-title">
      {{ title }}
    </h4>

    <spinner v-if="isLoading" width="100" height="100" />

    <template v-else>
      <div v-if="hasData" class="chart-container">
        <v-chart
          :key="category"
          class="chart-breakdown"
          :option="chartOptions"
          autoresize
        />
      </div>
      <div v-else class="zero-data">
        <p class="zero-state-message">
          No socio-demo breakdown data available on this account.
        </p>
      </div>
    </template>
  </div>
</template>
<script>
import Spinner from '@/components/common/Spinner'

export default {
    components: { Spinner },
    props: {
        category: { type: String, required: true },
        isLoading: { type: Boolean, required: true },
        breakdown: { type: Object, required: true }
    },
    computed: {
        title() {
            return this.category.charAt(0).toUpperCase() + this.category.slice(1)
        },
        hasData() {
            return !!(this.breakdown[this.category] && this.breakdown[this.category].length)
        },
        chartOptions() {
            const palette = ['#33A6FF', '#80D8FF', '#786AF4', '#FFB74D', '#F06292']

            return {
                color: palette,
                tooltip: {
                    trigger: 'item',
                    borderColor: 'white',
                    formatter: (params) => {
                        return `${params.marker} <b>${params.name}</b>: ${params.value}%`
                    }
                },
                legend: {
                    top: 'top',
                    left: 0,
                    orient: 'vertical',
                    textStyle: { fontFamily: 'weborama', fontSize: 14, color: '#000000' }
                },
                series: [{
                    type: 'pie',
                    radius: ['60%', '90%'],
                    left: '20%',
                    top: '25%',
                    label: { show: false },
                    data: this.breakdown[this.category].map(item => ({
                        value: item.value,
                        name: item.name
                    })),
                    itemStyle: {
                        borderWidth: 2,
                        borderColor: '#ffffff'
                    }
                }]
            }
        }
    }
}
</script>
<style lang="scss">
.breakdown {
  &.card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 18px 18px 10px 18px;
    display: flex;
    flex-direction: column;
    min-height: 400px;
      .card-title {
        display: flex;
        max-height: 10px;
        font-size: 14px;
        font-weight: 600;
        color: #374151;
        margin: 0 0 10px 0;
    }
  }

  .chart-breakdown {
    flex: 1;
    height: 100%;
  }
  .chart-container {
    flex: 1;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .tabs-breakdown {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;

    .tab {
      font-size: 12px;
      cursor: pointer;
      filter: opacity(0.5);

      &.active {
        font-weight: 500;
        filter: unset;
      }

      &:before {
        content: '';
        height: 9px;
        width: 9px;
        display: inline-block;
        background-color: #53A8E2;
        border-radius: 100%;
      }
    }

  }
  .spinner-wrapper {
    margin-top: 50px;
    text-align: center;
  }
  .zero-data {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }
}

@media (max-width: 1300px) {
  .breakdown.card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 18px 18px 10px 18px;
    display: flex;
    flex-direction: column;
    min-height: 391px;
    height: 100%;
      .card-title {
        display: flex;
        max-height: 10px;
        font-size: 14px;
        font-weight: 600;
        color: #374151;
        margin: 0 0 10px 0;
    }
  }
}
</style>
